export const radioTypes = {
  distributionTrend: [
    {
      value: 1,
      name: '分布',
    },
    {
      value: 2,
      name: '趋势',
    },
  ],
  feeProfit: [
    {
      value: 1,
      name: '结余',
    },
    {
      value: 2,
      name: '次均结余',
    },
  ],
};
